import { render, staticRenderFns } from "./PaymentVerification.vue?vue&type=template&id=1412966c&scoped=true"
import script from "./PaymentVerification.vue?vue&type=script&lang=ts"
export * from "./PaymentVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1412966c",
  null
  
)

export default component.exports